module.exports = __webpack_public_path__ + "static/img12-75f40eb0720d0da157e3ac7c025eee64.jpg";